const AlignImageRight = () => (
  <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="10" width="11" height="16" rx="2" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M3.29289 4.29289C3.68342 3.90237 4.31658 3.90237 4.70711 4.29289L7.70711 7.29289C8.09763 7.68342 8.09763 8.31658 7.70711 8.70711L4.70711 11.7071C4.31658 12.0976 3.68342 12.0976 3.29289 11.7071C2.90237 11.3166 2.90237 10.6834 3.29289 10.2929L4.58579 9H1C0.447715 9 0 8.55228 0 8C0 7.44772 0.447715 7 1 7H4.58579L3.29289 5.70711C2.90237 5.31658 2.90237 4.68342 3.29289 4.29289Z" fill="currentColor" />
  </svg>
)

export default AlignImageRight
